// frontend/src/components/common/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const ProtectedRoute = ({ 
  children, 
  requiredRoles = [], 
  fallbackPath = '/login' 
}) => {
  const { user, loading } = useAuth();

  // Mostrar loading mientras se verifica la autenticación
  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // Si no hay usuario, redirigir al login
  if (!user) {
    return <Navigate to={fallbackPath} replace />;
  }

  // Verificar roles requeridos
  if (requiredRoles.length > 0) {
    // Obtener el rol del usuario (puede ser string o objeto)
    let userRole = null;
    
    if (typeof user.rol === 'string') {
      userRole = user.rol;
    } else if (user.rol && typeof user.rol === 'object') {
      userRole = user.rol.nombre || user.rol.name || user.rol.tipo;
    }
    
    // Verificar si el usuario tiene el rol requerido
    if (!userRole || !requiredRoles.includes(userRole)) {
      return <Navigate to="/403" replace />;
    }
  }

  // Si pasa todas las verificaciones, mostrar el contenido
  return children;
};

export default ProtectedRoute;